import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/mid-1.png';
import _imports_1 from '@/assets/img/mid-2.png';

const _withScopeId = n => (_pushScopeId("data-v-65352436"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "license_header"
};
const _hoisted_2 = {
  class: "fl"
};
const _hoisted_3 = {
  class: "colorMain"
};
const _hoisted_4 = {
  class: "fr"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconExport-01 colorFFF"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Activation code ");

const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = {
  class: "ml10"
};
const _hoisted_9 = {
  class: "ellipise"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0,
  style: {
    "color": "#EC5048"
  }
};
const _hoisted_13 = {
  class: "fl licenseKey pr20"
};
const _hoisted_14 = {
  class: "ellipise pointer"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 0,
  class: "iconfont pointer"
};
const _hoisted_18 = {
  key: 1,
  class: "iconfont iconxiazai operateIcon pointer"
};
const _hoisted_19 = {
  class: "dialogHeader"
};
const _hoisted_20 = {
  class: "title fl"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconclose-01"
}, null, -1));

const _hoisted_22 = [_hoisted_21];

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "8px"
  }
}, "MID", -1));

const _hoisted_24 = {
  class: "question-tooltip"
};
const _hoisted_25 = {
  class: "question-tooltip-inner"
};
const _hoisted_26 = {
  class: "mid-coontent"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_28 = {
  class: "mid-coontent"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_30 = {
  class: "mid-coontent"
};
const _hoisted_31 = {
  class: "dialogFooter"
};
const _hoisted_32 = {
  class: "dialogHeader"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconclose-01"
}, null, -1));

const _hoisted_34 = [_hoisted_33];
const _hoisted_35 = {
  key: 0,
  class: "resultInfo"
};

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai operateIcon pointer"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _component_el_result = _resolveComponent("el-result");

  const _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.num), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("licenses available for distribution")), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_checkbox, {
    modelValue: _ctx.allSelect,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.allSelect = $event),
    onChange: _ctx.allSelectChange,
    label: _ctx.$t('All')
  }, null, 8, ["modelValue", "onChange", "label"]), _createElementVNode("button", {
    class: "export pointer",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => _ctx.exportFile && _ctx.exportFile(...args))
  }, _hoisted_7)])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    "header-row-class-name": "tableHeader",
    data: _ctx.dataList,
    style: {
      "width": "100%"
    },
    height: _ctx.computedHeight
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      width: "30"
    }, {
      header: _withCtx(() => [_createVNode(_component_el_checkbox, {
        onChange: _ctx.pageChange,
        modelValue: _ctx.pageAllSelect,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.pageAllSelect = $event),
        indeterminate: _ctx.pageIndeterminate
      }, null, 8, ["onChange", "modelValue", "indeterminate"])]),
      default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
        onChange: _ctx.change,
        disabled: scope.row.status == 1,
        modelValue: _ctx.dataList[scope.$index].selectStatus,
        "onUpdate:modelValue": $event => _ctx.dataList[scope.$index].selectStatus = $event
      }, null, 8, ["onChange", "disabled", "modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "License ID",
      width: "115"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.id), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: _ctx.$t("Type"),
      width: "120"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.license_type_name), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "mid",
      label: "MID",
      width: "140"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_9, [scope.row.mid ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        placement: "top"
      }, {
        content: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.mid || '-'), 1)]),
        default: _withCtx(() => [_createElementVNode("span", {
          onClick: $event => _ctx.copyKey(scope.row.mid),
          class: "pointer"
        }, _toDisplayString(scope.row.mid), 9, _hoisted_10)]),
        _: 2
      }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_11, " - "))])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: _ctx.$t("Status"),
      width: "130"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: _normalizeClass({
          [scope.row.status == 0 ? 'noGenerate' : 'generate']: true
        })
      }, _toDisplayString(scope.row.status == 0 ? _ctx.$t('Not generated') : _ctx.$t('Generated')), 3)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "generated_at",
      width: "125",
      label: _ctx.$t('Activation date')
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.generated_at ? scope.row.generated_at.substr(0, 10) : '-'), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "expired_at",
      width: "135",
      label: _ctx.$t('Term of validity')
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.expired_at ? scope.row.expired_at.substr(0, 10) : _ctx.dateComputed(scope.row.period)) + " ", 1), !scope.row.expired_at && scope.row.period && scope.row.period_day ? (_openBlock(), _createElementBlock("span", _hoisted_12, " + " + _toDisplayString(scope.row.period_day) + " " + _toDisplayString(_ctx.$t('days')), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "key",
      label: _ctx.$t('Activation code'),
      width: "150"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_13, [scope.row.key ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        placement: "top"
      }, {
        content: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.key), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_14, _toDisplayString(scope.row.key), 1)]),
        _: 2
      }, 1024)) : _createCommentVNode("", true), _createElementVNode("i", {
        class: "iconfont iconcopy-01 pointer",
        onClick: $event => _ctx.copyKey(scope.row.key)
      }, null, 8, _hoisted_15)])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "key_expired_at",
      width: "135"
    }, {
      header: _withCtx(() => [_createVNode(_component_el_tooltip, {
        content: _ctx.$t('Validity period of the Activation code'),
        placement: "top-start",
        effect: "light"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.getValue(_ctx.$t('Validity period of the Activation code'))), 1)]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.key_expired_at ? scope.row.key_expired_at.substr(0, 10) : '-'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: _ctx.$t('Operation'),
      width: "100"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", {
        onClick: $event => _ctx.handleLicense(scope.row)
      }, [scope.row.status == 0 ? (_openBlock(), _createElementBlock("a", _hoisted_17, _toDisplayString(_ctx.$t('Generate')), 1)) : (_openBlock(), _createElementBlock("i", _hoisted_18))], 8, _hoisted_16)]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["data", "height"])), [[_directive_loading, _ctx.loading]]), _createVNode(_component_el_pagination, {
    currentPage: _ctx.page,
    "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => _ctx.page = $event),
    "page-size": _ctx.size,
    "onUpdate:page-size": _cache[4] || (_cache[4] = $event => _ctx.size = $event),
    small: false,
    disabled: false,
    layout: "prev, pager, next, jumper",
    total: _ctx.total,
    onCurrentChange: _ctx.init,
    class: "fr page"
  }, null, 8, ["currentPage", "page-size", "total", "onCurrentChange"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogLicense,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _ctx.dialogLicense = $event),
    "show-close": false,
    width: "839px",
    "destroy-on-close": "",
    "close-on-click-modal": false,
    "custom-class": "mid-dialog"
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Generate license")) + ": " + _toDisplayString(_ctx.currentLicenseInfo.id), 1), _createElementVNode("div", {
      class: "fr close pointer",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.dialogLicense = false)
    }, _hoisted_22)])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_31, [!_ctx.sendEmail ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "Generate pointer",
      onClick: _cache[13] || (_cache[13] = $event => _ctx.Generate(0))
    }, _toDisplayString(_ctx.$t("generate")), 1)) : _createCommentVNode("", true), _ctx.sendEmail ? (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "Generate pointer",
      onClick: _cache[14] || (_cache[14] = $event => _ctx.Generate(0))
    }, _toDisplayString(_ctx.$t("Generate and Send")), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
      class: "close pointer",
      onClick: _cache[15] || (_cache[15] = $event => _ctx.dialogLicense = false)
    }, _toDisplayString(_ctx.$t("Cancel")), 1)])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: _ctx.form,
      rules: _ctx.rules,
      "label-width": "90px",
      ref: "FormRef",
      "label-position": "left"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        class: "is-required mb0",
        onPaste: _ctx.paste
      }, {
        label: _withCtx(() => [_hoisted_23, _createElementVNode("i", {
          class: "iconfont iconwenti question-mid",
          onClick: _cache[6] || (_cache[6] = //@ts-ignore
          (...args) => _ctx.questionShow && _ctx.questionShow(...args))
        }), _withDirectives(_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("What is Mid?")), 1), _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("MID is the unique serial number that detects the machine corresponding to your Goby client.")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("(Tips: The activation code/license is one code per machine, after the activation code/license is activated, it will not be able to use another computer or virtual machine, please fill in carefully.)")), 1), _hoisted_27, _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("Click the Activate License entry in the lower left corner to pop up the details of the unlock License privilege, and click the Configure button to enter the activation license interface")), 1), _hoisted_29, _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("In the license activation interface, there are three different ways to activate the license, namely activation code, license file, and account activation; Click the License file to view the MID information of your machine; In the Generate License bullet box, enter the MID serial number to generate the License file, fill in the License file or import it into your Goby client to complete the activation.")), 1)])], 512), [[_vShow, _ctx.isShowQueation]])]),
        default: _withCtx(() => [_withDirectives(_createElementVNode("span", {
          class: "not-mid"
        }, _toDisplayString(_ctx.$t("What you entered is an activation code, please enter the correct MID; Please click on the question mark on the left to learn about MID and how to activate License~")), 513), [[_vShow, _ctx.isNotMid]]), _createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              "label-width": "0px",
              prop: "mid1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _ctx.form.mid1,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.form.mid1 = $event),
                maxlength: "8"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              "label-width": "0px",
              prop: "mid2"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _ctx.form.mid2,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.form.mid2 = $event),
                maxlength: "8"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              "label-width": "0px",
              prop: "mid3"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _ctx.form.mid3,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.form.mid3 = $event),
                maxlength: "8"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              "label-width": "0px",
              prop: "mid4"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _ctx.form.mid4,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.form.mid4 = $event),
                maxlength: "8"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["onPaste"]), _ctx.sendEmail ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.$t('Email'),
        prop: "email",
        class: _normalizeClass(['label-w', 'mt32', 'mb0', _ctx.lang == 'en' && _ctx.isNotMid ? 'mt55' : ''])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.email,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.form.email = $event),
          placeholder: _ctx.$t('Please enter your current email address')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label", "class"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
        class: _normalizeClass(['mt18', _ctx.lang == 'en' && _ctx.isNotMid && !_ctx.sendEmail ? 'mt40' : ''])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: _ctx.$t('License sending to the E-mail'),
          name: "type",
          modelValue: _ctx.sendEmail,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _ctx.sendEmail = $event)
        }, null, 8, ["label", "modelValue"])]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogResult,
    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _ctx.dialogResult = $event),
    "show-close": false,
    width: "839px",
    "destroy-on-close": "",
    "custom-class": "dialogResult"
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", {
      class: "fr close pointer",
      onClick: _cache[17] || (_cache[17] = $event => _ctx.dialogResult = false)
    }, _hoisted_34)])]),
    default: _withCtx(() => [_createVNode(_component_el_result, {
      icon: "success",
      title: _ctx.sendEmail ? _ctx.$t('Sent successfully') : _ctx.$t('Generated')
    }, {
      extra: _withCtx(() => [_createElementVNode("div", null, [_ctx.sendEmail ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("p", null, [_createTextVNode(_toDisplayString(_ctx.$t('Detailed description and offline license file / online activation code have been sent to the')) + " ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.form.email), 1), _createTextVNode("，" + _toDisplayString(_ctx.$t("please check~")), 1)])])) : _createCommentVNode("", true), _createElementVNode("p", {
        class: "down-text",
        onClick: _cache[18] || (_cache[18] = $event => _ctx.Generate(1))
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Download license")), 1), _hoisted_36])])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}